import { render, staticRenderFns } from "./SettingsMessageTemplates.vue?vue&type=template&id=58e6ba38&scoped=true&"
import script from "./SettingsMessageTemplates.vue?vue&type=script&lang=js&"
export * from "./SettingsMessageTemplates.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMessageTemplates.vue?vue&type=style&index=0&id=58e6ba38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6ba38",
  null
  
)

export default component.exports